<ng-container [ngSwitch]="mode">
  <ion-radio-group *ngSwitchCase="'radio'" class="card-compact-list" [formControl]="innerControl">
    <div class="card" *ngFor="let opt of options" (click)="onClick($event, opt)">
      <div class="radio-label">{{ displayFn(opt) }}</div>
      <div class="flex">
        <ion-radio [value]="valueFn(opt)"></ion-radio>
      </div>
    </div>
  </ion-radio-group>

  <div *ngSwitchCase="'select'" class="select-inner">
    <ion-item lines="none" *ngIf="disabled">
      <ion-label>{{ label }}</ion-label>
      <ion-input [disabled]="true">{{ displayFn(innerControl.value) }}</ion-input>
    </ion-item>
    <ion-item lines="none" *ngIf="!disabled">
      <ion-label>{{ label }}</ion-label>
      <ion-select
        [placeholder]="placeholder"
        interface="popover"
        class="select-popover"
        #select
        [formControl]="innerControl"
        [okText]="'SELECT_OK' | transloco"
        [cancelText]="'SELECT_CANCEL' | transloco"
      >
        <ion-select-option *ngFor="let opt of options" [value]="valueFn(opt)">{{ displayFn(opt) }} </ion-select-option>
      </ion-select>
    </ion-item>
  </div>

  <div *ngSwitchCase="'checklist'" class="card-compact-list checklist">
    <div class="card" *ngFor="let opt of options" (click)="onClick($event, opt)">
      <div class="flex flex-row items-center">
        @let icon = displayIconFn(opt);
        @if (icon) {
          @let isFromAssets = icon | isIconFromAssets;
          @if (isFromAssets) {
            <ion-icon class="mr-12" [src]="icon"></ion-icon>
          } @else {
            <ion-icon class="mr-12" [name]="icon"></ion-icon>
          }
        }
        <div class="radio-label">{{ displayFn(opt) }}</div>
      </div>
      <ion-icon *ngIf="opt.value === innerControl.value" class="success-color" name="checkmark-sharp"> </ion-icon>
    </div>
  </div>
</ng-container>
